import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import Badge from '@components/ringil3/Badges/Badge';
import { isNotNullOrUndefined } from '@utils/utils';

interface ComponentProps {
  streetNr?: string;
  country?: string;
  zipCode?: string;
  city?: string;
  timezoneId?: string;
}

const AddressBadge: React.FC<ComponentProps> = ({ country, zipCode, city, streetNr, timezoneId }) => {
  const { tr } = useTranslationLgs();
  const addressParts = [country, zipCode, city, streetNr, timezoneId].filter(isNotNullOrUndefined);

  if (addressParts.length === 0) return null;

  return (
    <Badge
      filled={false}
      value={addressParts.join(' | ')}
      highlightedValue={false}
      label={tr('AddressBadge.label', 'Address')}
    />
  );
};

export default AddressBadge;